import Section from "@/components/ui/section";
import React from "react";
import { servicesLarge } from "@/components/data/services-large";
import Check from "@/components/ui/icons/check";
import { m } from "framer-motion";
import Image from "next/image";
export default function ServicesGrid() {
  return (
    <Section className="bg-[#fafafa]" variant="zero">
      <m.div
        initial={{ y: 40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 100 }}
        transition={{ duration: 0.75 }}
        className="flex flex-col w-full md:gap-12 gap-[30px]"
      >
        {servicesLarge?.map((service, key) => (
          <Block key={"service" + key} data={service} />
        ))}
      </m.div>
    </Section>
  );
}
const Block = ({ data }) => {
  return (
    <div
      id={data?.id}
      className="flex lg:flex-row md:flex-col flex-col-reverse w-full md:gap-[50px] gap-6 shadow-serviceCard rounded-[20px] bg-white md:p-[40px] p-4 last:mb-16"
    >
      <div className="lg:w-[55%] w-full flex flex-col gap-4 justify-center">
        {data?.title && (
          <div
            className="md:text-3xl text-xl text-blue font-semibold [&>span]:text-blue md:leading-normal leading-tight"
            dangerouslySetInnerHTML={{ __html: data?.title }}
          />
        )}
        {data?.description && (
          <div className="text-[#2a2a2a] leading-normal">
            {data?.description}
          </div>
        )}
        {data?.points && (
          <ul className="md:text-base text-sm md:leading-normal leading-tight list-none flex flex-col gap-2 pl-0 w-full">
            {data?.points?.map((point, key) => (
              <li
                key={"point" + key}
                className="flex items-center gap-4 text-[#333333] font-medium"
              >
                <Check className="text-[#dd5324] w-5 h-5" />
                {point}
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="lg:w-[45%] w-full flex flex-col gap-4 relative lg::h-[500px] md:h-[400px] h-[200px] rounded-2xl overflow-hidden">
        <Image
          src={data?.image ?? "/images/placeholder.svg"}
          alt={data?.title}
          fill
          className="object-cover object-center"
          sizes="(max-width: 479px) 700px,(max-width: 768px) 700px, (max-width: 1200px) 700px,(max-width: 1920px) 700px, 500px"
        />
      </div>
    </div>
  );
};
